// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5 14C20.0899 14 23 11.0899 23 7.5C23 3.91015 20.0899 1 16.5 1C12.9101 1 10 3.91015 10 7.5C10 11.0899 12.9101 14 16.5 14Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.1426 15.9759C16.9305 15.9918 16.7162 15.9999 16.5 15.9999C11.8056 15.9999 8 12.1943 8 7.49987C8 7.2838 8.00806 7.06961 8.0239 6.85758C6.48848 8.0465 5.5 9.90782 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5C14.0923 18.5 15.9537 17.5115 17.1426 15.9759Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.6423 20.476C12.4303 20.4919 12.2161 20.4999 12 20.4999C7.30558 20.4999 3.5 16.6944 3.5 11.9999C3.5 11.7838 3.50807 11.5695 3.52392 11.3573C1.98849 12.5463 1 14.4076 1 16.4998C1 20.0897 3.91015 22.9998 7.5 22.9998C9.59214 22.9998 11.4534 22.0114 12.6423 20.476Z"}}]};

const AnimationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'animation-filled',
    ref,
    icon: element,
  },
));

AnimationFilledIcon.displayName = 'AnimationFilledIcon';

export default AnimationFilledIcon;
